import actionTypes from "./actionTypes";

const actions = {
  postSupport: (data, options = {}) => ({
    ...options,
    type: actionTypes.POST_SUPPORT,
    payload: {
      data,
    },
  }),
  storeAlerted: (id) => ({
    type: actionTypes.STORE_ALERTED,
    payload: id,
  }),
  storeLoading: (type, loading) => ({
    type: actionTypes.STORE_LOADING,
    payload: {
      type,
      loading,
    },
  }),
  storeNotification: (variant, message) => ({
    type: actionTypes.STORE_NOTIFICATION,
    payload: {
      message,
      variant,
    },
  }),
  storeSettings: (settings) => ({
    type: actionTypes.STORE_SETTINGS,
    payload: settings,
  }),
};

export default actions;
